class ComparisonTool {
  readonly CHECKBOX_CHECKED_EVENT: string = "comparisonCheckboxChecked";
  readonly PRODUCT_REMOVED_MODAL_EVENT: string =
    "comparisonModalProductRemoved";

  subcategoryId: string;

  constructor() {
    this.subcategoryId = window._THULEDATA.ComparisonModal.SubcategoryId;

    this.setupCheckboxes();
    this.setupCheckboxEvents();
  }

  setupCheckboxes = () => {
    let productIdsJson = localStorage.getItem(this.subcategoryId);

    if (!productIdsJson) return;

    let productIds: string[] = JSON.parse(productIdsJson);

    productIds.forEach((id) => {
      let checkbox = document.querySelector(
        `#compare-${id}`
      ) as HTMLInputElement;
      if (!checkbox) return;
      checkbox.checked = true;
    });
  };

  setupCheckboxEvents = () => {
    let comparisonCheckboxes = document.querySelectorAll(
      ".thule-checkbox.compare input"
    );

    comparisonCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", (event) => {
        let checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
          this.tryAddToComparison(checkbox.dataset.productId!, checkbox);
        } else {
          this.removeFromComparison(checkbox.dataset.productId!);
        }
      });
    });

    document.addEventListener(this.PRODUCT_REMOVED_MODAL_EVENT, () => {
      this.resetCheckboxes();
      this.setupCheckboxes();
    });
  };

  resetCheckboxes = () => {
    let checkboxes = document.querySelectorAll(".thule-checkbox.compare input");

    checkboxes.forEach((elem) => {
      let checkbox = elem as HTMLInputElement;
      checkbox.checked = false;
    });
  };

  tryAddToComparison = (productId: string, checkbox: HTMLInputElement) => {
    if (!localStorage.getItem(this.subcategoryId))
      localStorage.setItem(this.subcategoryId, JSON.stringify([]));

    let comparisonList: string[] = JSON.parse(
      localStorage.getItem(this.subcategoryId)!
    );

    let allowedCount = window.innerWidth < 768 ? 2 : 4;

    if (comparisonList.length >= allowedCount) {
      checkbox.checked = false;
      return;
    }

    comparisonList.push(productId);
    localStorage.setItem(this.subcategoryId, JSON.stringify(comparisonList));
    document.dispatchEvent(new Event(this.CHECKBOX_CHECKED_EVENT));
  };

  removeFromComparison = (productId: string) => {
    let comparisonList: string[] = JSON.parse(
      localStorage.getItem(this.subcategoryId)!
    );
    let updatedList = comparisonList.filter((id) => id !== productId);

    if (updatedList.length === 0) {
      localStorage.removeItem(this.subcategoryId);
    } else {
      localStorage.setItem(this.subcategoryId, JSON.stringify(updatedList));
    }

    document.dispatchEvent(new Event(this.CHECKBOX_CHECKED_EVENT));
  };
}

document.addEventListener("DOMContentLoaded", () => {
  new ComparisonTool();
});